import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TableAgGridv31 from './TableAgGridv31';

const FRAMEWORK_TO_STANDARD_PROPS = [
  ['cellRendererFramework', 'cellRenderer'],
  ['loadingCellRendererFramework', 'loadingCellRenderer'],
  ['detailCellRendererFramework', 'detailCellRenderer'],
  ['headerComponentFramework', 'headerComponent'],
  ['headerGroupComponentFramework', 'headerGroupComponent'],
  ['tooltipComponentFramework', 'tooltipComponent'],
  ['filterFramework', 'filter'],
  ['floatingFilterComponentFramework', 'floatingFilterComponent'],
  ['innerRendererFramework', 'innerRenderer'],
];

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && Object.prototype.toString.call(value) === '[object Object]';

const normalizeFrameworkPropsDeep = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeFrameworkPropsDeep);
  }

  if (!isPlainObject(value)) {
    return value;
  }

  const normalizedObject = {};

  Object.entries(value).forEach(([key, childValue]) => {
    normalizedObject[key] = normalizeFrameworkPropsDeep(childValue);
  });

  FRAMEWORK_TO_STANDARD_PROPS.forEach(([legacyProp, standardProp]) => {
    if (Object.prototype.hasOwnProperty.call(normalizedObject, legacyProp)) {
      if (normalizedObject[standardProp] === undefined) {
        normalizedObject[standardProp] = normalizedObject[legacyProp];
      }
      delete normalizedObject[legacyProp];
    }
  });

  return normalizedObject;
};

const normalizeGridOptionsFrameworkProps = (gridOptions) => {
  if (!isPlainObject(gridOptions)) return gridOptions;

  let changed = false;
  const nextGridOptions = { ...gridOptions };

  ['colDefsMedalsIncluded', 'colDefsMedalsExcluded'].forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(gridOptions, key)) return;
    const currentValue = gridOptions[key];
    const normalizedValue = normalizeFrameworkPropsDeep(currentValue);
    if (normalizedValue !== currentValue) {
      nextGridOptions[key] = normalizedValue;
      changed = true;
    }
  });

  return changed ? nextGridOptions : gridOptions;
};

const TableAgGridv31Wrapper = ({
  IsShowCard = true,
  addedClass = '',
  hideExcelDownloadIcon = false,
  isComp = false,
  isInvest = false,
  pageTitle = '',
  smalltitle = '',
  title = '',
  extratitle = '',
  cancelSlideBottomToUp = false,
  showInfoLable,
  linebreakInfoLable,
  isLandscape = false,
  isFullWidth = false,
  gridOptions,
  gridOptionsFooter,
  ...restProps
}) => {
  const newGridOptions = useMemo(() => {
    if (!gridOptions) return gridOptions;
    return normalizeGridOptionsFrameworkProps(gridOptions);
  }, [gridOptions]);
  const newGridOptionsFooter = useMemo(() => {
    if (!gridOptionsFooter) return gridOptionsFooter;
    return normalizeGridOptionsFrameworkProps(gridOptionsFooter);
  }, [gridOptionsFooter]);

  return (
    <>
      <TableAgGridv31
        {...restProps}
        IsShowCard={IsShowCard}
        addedClass={addedClass}
        hideExcelDownloadIcon={hideExcelDownloadIcon}
        isComp={isComp}
        isInvest={isInvest}
        pageTitle={pageTitle}
        smalltitle={smalltitle}
        title={title}
        extratitle={extratitle}
        cancelSlideBottomToUp={cancelSlideBottomToUp}
        showInfoLable={showInfoLable}
        linebreakInfoLable={linebreakInfoLable}
        isLandscape={isLandscape}
        isFullWidth={isFullWidth}
        gridOptions={newGridOptions}
        gridOptionsFooter={newGridOptionsFooter}
      />
    </>
  );
};
TableAgGridv31Wrapper.propTypes = {
  IsShowCard: PropTypes.bool,
  addedClass: PropTypes.string,
  gridOptions: PropTypes.object.isRequired,
  gridOptionsFooter: PropTypes.object,
  hideExcelDownloadIcon: PropTypes.bool,
  isComp: PropTypes.bool,
  isInvest: PropTypes.bool,
  pageTitle: PropTypes.string,
  smalltitle: PropTypes.string,
  title: PropTypes.string,
  extratitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelSlideBottomToUp: PropTypes.bool,
  showInfoLable: PropTypes.any,
  linebreakInfoLable: PropTypes.any,
  isLandscape: PropTypes.bool,
  isFullWidth: PropTypes.bool,
};

export default React.memo(TableAgGridv31Wrapper);
